export const modules = [
  {
    number: '01',
    title: 'Foundational and core concepts',
    topics: [
      'Principles and practices',
      'Strategy',
      'Vision and mission',
      'Ethics and trust building'
    ]
  },
  {
    number: '02',
    title: 'Essential leadership skills',
    topics: [
      'Communication',
      'Decision making',
      'Delegation',
      'Strategic thinking',
      'Problem solving'
    ]
  },
  {
    number: '03',
    title: 'People management and team dynamics',
    topics: [
      'Team motivation',
      'Feedback',
      'Conflict resolution',
      'Building high-performing teams',
      'Performance management',
      'Coaching and mentoring'
    ]
  },
  {
    number: '04',
    title: 'Personal development and modern leadership',
    topics: [
      'Emotional intelligence',
      'Time management',
      'Resilience',
      'Change management',
      'Diversity, equity and inclusion'
    ]
  }
];

export const specifications = [
  ['Formats', '.docx (Word), .pptx (PowerPoint), .pdf'],
  ['Length', '300+ pages of core content'],
  ['Module size', 'Approximately 15–20 pages each'],
  ['Editable', 'Yes, files fully unlocked'],
  ['Licence', 'Private label rights'],
  ['Delivery', 'Instant download'],
  ['Access', 'Pay once, keep forever']
];

export const audiences = [
  ['Digital product sellers', 'A complete catalogue in one niche, ready to list.'],
  ['Course creators', 'The written backbone your video course needs around it.'],
  ['Coaches and consultants', 'Client material you customise instead of writing.'],
  ['Agencies', 'A content base you deploy across multiple client brands.']
];

export const faqs = [
  {
    question: 'Can I sell this on Etsy, Gumroad or my own site?',
    answer: "Yes, once you've edited and rebranded it. What you can't do is list the folder unedited as a bundle competing with this one."
  },
  {
    question: 'Can my buyers resell it?',
    answer: 'No. Resale rights stop with you. Your customers buy a finished product, not the source files.'
  },
  {
    question: 'How much editing does it actually need?',
    answer: 'Branding and examples, at minimum. Roughly an hour per module. The writing itself is publication-ready.'
  },
  {
    question: 'What software do I need?',
    answer: 'Microsoft Word and PowerPoint, or anything that opens .docx and .pptx — Google Docs and Slides both work.'
  },
  {
    question: 'How do I get the files?',
    answer: 'Instant download from Gumroad after checkout. No waiting, no email sequence.'
  }
];